import { IObjectAudit } from "../../ObjectAudit"

export interface ITrendSettingsDocument {
    Id: string,
    AccountId: string,
    TypeCode: string,
    Name: string,
    Description: string,
    UnitName: string,
    UnitType: ETrendUnitType,
    ObjectName: string,
    ThresholdUpperLimit: number,
    ThresholdLowerLimit: number,
    TimeScopes: ETrendTimeScope[],
    EmployeeFlagSetting: IEmployeeFlagSetting
    AggregationSettings: ITrendAggregationSettings
    TrendType: ETrendType
}

export interface ITrendDocument{
    Id: string,
    AccountId: string,
    TrendSettingsId: string,
    ParentHierarchyId: string,
    ObjectId: string,
    ObjectName: string,
    LeafNode: boolean, 
    TimeScope: ETrendTimeScope,
    StartDate: Date | null,
    EndDate: Date | null,
    TimeSeriesData: ITrendTimeSeriesData[], 
    AverageValue: number,
    ActualToProjectedVariance: number,
    TicksSinceChange: number,
    Deleted: boolean,
    EmployeeFlagSetting: IEmployeeFlagSetting,
    ObjectAudit: IObjectAudit, 
  }

export interface ITrendTimeSeriesData{
    DateTime: Date,
    Value: number,
    Numerator: number,
    Denominator: number,
    ProjectedValue: number,
    ActualToProjectedVariance: number,
    PreviousPeriodVariance: number,
    NextPeriodVariance: number,
    OutsideOfThreshold: boolean,
    FlagId: string,
    ObjectAudit: IObjectAudit
}


export enum ETrendTimeScope {
    Hourly = 0,
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
    Quarterly = 4,
    SemiAnnualy = 5, //Every six months
    Annualy = 6,
}

export enum ETrendType {
    /// <summary>
    /// Upward or downward trends over time.
    /// </summary>
    Growth = 0,
    /// <summary>
    /// Repeating patterns that are cyclical or seasonal.
    /// </summary>
    Pattern = 1,
    /// <summary>
    /// These are typically ratios and are governed by "normal" upper and lower ranges.
    /// </summary>
    Bounded = 3,
}

export interface IEmployeeFlagSetting{
    Id: string,
    Name: string,
    EmployeeFlagType: EEmployeeFlagType,
    ObjectAudit: IObjectAudit,
    Active: boolean,
    TicksSinceChange: number,
    Deleted: boolean,
    PreventStatusChange: boolean,
    PreventPipelineStageMove: boolean,
    SetUserTLMInactive: boolean
}

export interface ITrendAggregationSettings{
    NegativeGrowthPreferred: boolean
    AggregationType: ETrendAggregationType
    NumeratorName: string
    DenominatorName: string
}

export enum EEmployeeFlagType
{
    Other = 0,
    DuplicateGovernmentId = 1,
    AgeThresholdIssue = 2,
}

export enum ETrendUnitType
{
    Double = 0,
    Integer = 1,
    Percentage = 2,
}

export enum ETrendAggregationType
{
    Summation = 0,
    Average = 1,
}

export interface ITrendSearch {
    TotalDocumentCount: number,
    Documents: ITrendDocument[],
    GroupedTrends: IGroupedTrend[],
    TrendSettings: ITrendSettingsDocument[]
}
  
export interface  IGroupedTrend {
    Id: string
    ParentHierarchyId: string
    HierarchyId: string
    HierarchyName: string
    ObjectId: string
    ObjectName: string
    Settings: ITrendSettingsDocument,
    Totals: ITrendTotals,
    SeriesData: ITrendTimeSeriesData[],
    LeafNode: boolean
}

export interface ITrendTotals{
    ChangedValue: number,
    PeriodTotal: number,    
}